import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SegmentClassificationMapArrayModel,
  SegmentClassificationMapModel,
} from "../../models/SegmentClassificationMapModel";

const initialState: SegmentClassificationMapArrayModel = {
  all_Segment_Classification_Map: [],
  isSegmentClassificationMapsFetching: false,
};
const SegmentClassificationMapSlice = createSlice({
  name: "SegmentClassificationMap",
  initialState: initialState,
  reducers: {
    setSegmentClassificationMap(
      state,
      action: PayloadAction<SegmentClassificationMapModel[]>
    ) {
      state.all_Segment_Classification_Map = action.payload;
    },
    setIsSegmentClassificationMapsFetching(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isSegmentClassificationMapsFetching = action.payload;
    },
  },
});
export default SegmentClassificationMapSlice;
